import React, { useState, useEffect } from 'react';
import { Card, Flex, Typography } from 'antd';
import { DatabaseFilled, FileTextFilled, FilterFilled } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

const { Text, Title } = Typography;

const FileValidationCard = () => {
	const { t } = useTranslation();
	const [currentStep, setCurrentStep] = useState(0);

	useEffect(() => {
		const stepTimer = setInterval(() => {
			setCurrentStep((prev) => (prev + 1) % 3);
		}, 2000);
		return () => clearInterval(stepTimer);
	}, []);

	const steps = [
		{ icon: <FileTextFilled />, label: t('loadStatusDetails.validationLoadingStepChecking')},
		{ icon: <FilterFilled />, label: t('loadStatusDetails.validationLoadingStepValidating') },
		{ icon: <DatabaseFilled />, label: t('loadStatusDetails.validationLoadingStepPreparing') }
	];

	return (
		<Flex justify='center'>
			<Card
				bordered={false}
				style={{
					width: 1000,
					marginTop: '1.5rem',
					marginBottom: '1rem',
					borderRadius: '8px',
					boxShadow: '0 1px 2px 0 rgba(0, 0, 0, 0.03), 0 1px 6px -1px rgba(0, 0, 0, 0.02), 0 2px 4px 0 rgba(0, 0, 0, 0.02)'
				}}
				bodyStyle={{
					padding: '1rem 1.5rem'
				}}
			>
				<div className="validation-container">
					{/* SVG Container */}
					<div className="csv-animation-container">
						<img
							src="/assets/csv-scanning.svg"
							alt="CSV Validation"
							style={{
								width: '140px',
								height: '140px'
							}}
						/>
					</div>

					{/* Content */}
					<div className="content-container">
						<Title level={4} style={{
							margin: 0,
							color: '#13c2c2',
							// fontWeight: 500
						}}>
							{t('loadStatusDetails.validationTitle')}
						</Title>
						<Text  style={{
							fontSize: '14px',
							display: 'block',
							marginTop: '4px'
						}}>
							{t('loadStatusDetails.validationDescription')}
						</Text>

						{/* Rotating Status Text */}
						<div style={{
							marginTop: '1.5rem',
							height: '32px',
							overflow: 'hidden',
							position: 'relative',
							display: 'flex',
							alignItems: 'center'
						}}>
							<div style={{
								width: '32px',
								height: '32px',
								borderRadius: '50%',
								background: '#13c2c2',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								color: 'white',
								fontSize: '18px',
								marginRight: '12px',
								flexShrink: 0
							}}>
								{steps[currentStep].icon}
							</div>
							<div style={{
								position: 'relative',
								height: '32px',
								flex: 1,
								overflow: 'hidden'
							}}>
								<div style={{
									position: 'absolute',
									width: '100%',
									transform: `translateY(-${currentStep * 32}px)`,
									transition: 'transform 0.5s ease-in-out'
								}}>
									{steps.map((step, index) => (
										<div
											key={index}
											style={{
												height: '32px',
												display: 'flex',
												alignItems: 'center',
												gap: '8px'
											}}
										>
											<Text style={{
												fontSize: '14px',
												fontWeight: 500
											}}>
												{step.label}
											</Text>
											<div style={{
												display: 'flex',
												gap: '3px'
											}}>
												{[0, 1, 2].map((dot) => (
													<div
														key={dot}
														style={{
															width: '4px',
															height: '4px',
															borderRadius: '50%',
															background: '#13c2c2',
															animation: `pulse 1.4s ease-in-out infinite ${dot * 0.3}s`
														}}
													/>
												))}
											</div>
										</div>
									))}
								</div>
							</div>
						</div>

					</div>
				</div>

				{/* CSS Animations and Responsive Styles */}
				<style jsx>{`
					@keyframes pulse {
						0%, 100% { opacity: 0.3; }
						50% { opacity: 1; }
					}

					/* Mobile styles (default) */
					.validation-container {
						display: flex;
						flex-direction: column;
						align-items: center;
						text-align: center;
					}

					.csv-animation-container {
						margin-bottom: 1.5rem;
					}

					.content-container {
						width: 100%;
						padding: 0 !important;
					}

					/* Desktop styles */
					@media (min-width: 768px) {
						.validation-container {
							flex-direction: row;
							align-items: center;
							text-align: left;
							gap: 2rem;
						}

						.csv-animation-container {
							margin-bottom: 0;
							flex: 0 0 auto;
						}

						.content-container {
							flex: 1;
							padding: 0 !important;
						}
					}
				`}</style>
			</Card>
		</Flex>
	);
};

export default FileValidationCard;